<template>
  <div ref="menu">
    <ul @click="close">
      <template v-if="data.data.access_status !== 'GUEST'">
        <li @click="edit">
          <img src="@/assets/Edit-User-Pen.svg" width="16px" height="16px" /> &nbsp;&nbsp;<span>Edit</span>
        </li>
        <li @click="block" v-if="data.data.data.isActive">
          <img src="@/assets/Delete-User.svg" width="18px" height="16px" /> &nbsp;&nbsp;<span>Block</span>
        </li>
        <li @click="unblock" v-if="!data.data.data.isActive">
          <img src="@/assets/Unblock-User.svg" width="18px" height="16px" /> &nbsp;&nbsp;<span>Unblock</span>
        </li>
        <li @click="deleteuser">
          <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" /> &nbsp;&nbsp;<span>Delete</span>
        </li>
      </template>
      <template v-else>
        <li>
          <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" /> &nbsp;&nbsp;<span>Remove Guest</span>
        </li>
      </template>
    </ul>
  </div>
</template>
<style scoped>
ul li {
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 13px;
}
</style>
<script>
import config from '@/services/config'
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  props: {
    data: {
      data: Object,
      index: Number
    }
  },
  data() {
    return {}
  },
  methods: {
    edit() {
      this.$parent.edit_user(this.data.index)
    },
    block() {
      this.$parent.blockuser(this.data.index, this.data.data.data._id, this.data.data.names)
    },
    unblock() {
      this.$parent.unblockuser(this.data.index, this.data.data.data._id, this.data.data.names)
    },
    deleteuser() {
      this.$parent.delete_user(this.data.data.data._id, this.data.data.names, this.data.index)
    },
    close() {
      this.$parent.close_drop_down(this.data.index)
    },
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SET_FILE_INFO_DATA',
      'SET_CURRENT_FILE_ID',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'HIDE_FILE_INFO',
      'SET_FILE_INDEX',
      'SET_FILES_INDEX',
      'SET_SELECT_ALL',
      'REMOVE_FILES_INDEX',
      'EMPTY_FILES_INDEX',
      'SET_SELECT_ALL',
      'SET_DB',
      'SET_CAN_CREATE',
      'SET_CREATE_RIGHT',
      'SET_EDIT_RIGHT',
      'SET_DOWNLOAD_RIGHT',
      'SET_PRINT_RIGHT',
      'SET_GROUP_CREATE_MODE'
    ])
  }
}
</script>
